import { useToast, POSITION } from "vue-toastification";
import type { ToastOptions } from "vue-toastification/dist/types/types";
import ToastUndo from "@/components/Toasts/ToastUndo.vue";

export const toast = useToast();

export { POSITION };

export const defaultOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: false,
  hideProgressBar: true,
  icon: false,
  toastClassName: "bg-link-blue font-semibold",
};

export function infoToast(msg: string, options?: ToastOptions) {
  return toast(msg, {
    ...defaultOptions,
    ...options,
  });
}

export function errorToast(msg: string, options?: ToastOptions) {
  return toast(msg, {
    ...defaultOptions,
    position: options?.position || POSITION.TOP_RIGHT,
    toastClassName: "bg-link-red font-semibold",
  });
}

export async function toastWithUndo(
  optimisticFn: () => any,
  actualFn: () => any,
  undoFn: () => any,
  toastMsg: string,
  delayMs: number = 6000
) {
  await optimisticFn();
  const timeoutId = setTimeout(() => {
    actualFn();
  }, delayMs);
  return toast(
    {
      component: ToastUndo,
      props: {
        msg: toastMsg,
      },
      listeners: {
        undo: () => {
          clearTimeout(timeoutId);
          undoFn();
        },
      },
    },
    {
      ...defaultOptions,
      timeout: delayMs,
      position: POSITION.BOTTOM_RIGHT,
      hideProgressBar: false,
    }
  );
}
